const SHOW_PLAYLIST_MODAL = 'SHOW_PLAYLIST_MODAL';
const CLOSE_PLAYLIST_MODAL = 'CLOSE_PLAYLIST_MODAL';

export { SHOW_PLAYLIST_MODAL, CLOSE_PLAYLIST_MODAL };
